<template>
  <div>
    <header>
   <header>
      <h1>Dreispalter mit Flex </h1> <span class="menulink"><a href="#navi">Menü</a></span></header>
    </header>
    <div class="flexcontainer">
        <nav id="navi" class="mainnav">
          <ul>
              <li><a href="#">Seite 1</a></li>
              <li><a href="#">Seite 2 mit langem Text</a></li>
              <li><a href="#">Seite 3</a></li>
              <li><a href="#">Seite 4</a></li>
              <li><a href="#">Seite 5</a></li>
          </ul>
        </nav>
        <section class="maincontent">
          <h2>Hauptinhalt</h2>
          <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
        </section>
        <aside class="marginalie">
          <h2>Marginalie </h2>
          <p>In der Marginalie werden zusätzliche Inhalte dargestellt</p>
        </aside>
    </div>
    <footer> Dreispalter mit Flex </footer>

  </div>
</template>

<script>
export default {
  name: "Dreispalter-FlexView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
         /* Mobile-First-Ansatz*/
      /* Alle Ansichten */
      
      .flexcontainer {
         /*display: flex;*/
         display: block;
         flex-wrap: wrap;
         flex-direction: column;
      }
      
      .mainnav {
         background: #99ccff;
         width: 100%;
         order: 4;
      }
      
      .maincontent {
         flex: 2;
         background: #ccccff;
      }
      
      .marginalie {
         flex: 1;
         background: #ffffcc;
      }
      
      footer {
         flex: 1 1 100%;
         order: 3;
      }
      
      .maincontent,
      .marginalie,
      .mainnav {
         margin: 0;
         padding: 0.5em;
         box-sizing: border-box;
      }
      
      .mainnav h3,
      .marginalie h3,
      .marginalie p,
      .mainnav ul {
         margin: 0.3em;
         list-style: none;
      }
      
      .mainnav ul {
         padding-left: 0;
         display: flex;
         flex-direction: column;
         flex-wrap: nowrap;
      }
      
      .mainnav li {
         padding: 0.2em 1em;
         margin: 0.3em 0;
         border: 1px solid gray;
         text-align: center;
      }
</style>



// WEBPACK FOOTER //
// src/components/css-examples/dreispalter-flex.vue